module.exports = __webpack_public_path__ + "img/kari2.b265c848.png";